import { Routes } from '@angular/router';
import { DashboardComponent } from './Clients/dashboard/dashboard.component';
import { LayoutComponent } from './Shared/Components/layout/layout.component';
import { InnerLayoutComponent } from './Shared/Components/inner-layout/inner-layout.component';
import { authgaurdGuard as AuthGuard } from './core/gaurd/authgaurd.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./Shared/Components/user-login-layout/user-login-layout.component')
        .then(m => m.UserLoginLayoutComponent),

    children: [

      {
        path: '',
        loadComponent: () =>
          import('./Clients/Static-Pages/home/home.component')
            .then(m => m.HomeComponent),
        pathMatch: 'full',
      },

      {
        path: 'login',
        loadComponent: () =>
          import('./Clients/Authantication/user-login/user-login.component')
            .then(m => m.UserLoginComponent)
      },

      {
        path: 'register',
        loadComponent: () =>
          import('./Clients/Authantication/user-registration/user-registration.component')
            .then(m => m.UserRegistrationComponent)
      },

      {
        path: 'forget-password',
        loadComponent: () =>
          import('./Clients/Authantication/forget-password/forget-password.component')
            .then(m => m.ForgetPasswordComponent)
      },

      {
        path: 'updatepassword',
        loadComponent: () =>
          import('./Clients/Authantication/reset-password/reset-password.component')
            .then(m => m.ResetPasswordComponent)
      },
      {
        path: 'resetlink',
        loadComponent: () =>
          import('./Clients/Authantication/user-login/user-login.component')
            .then(m => m.UserLoginComponent)
      },
      {
        path: 'about-us',
        loadComponent: () =>
          import('./Clients/Static-Pages/about-us/about-us.component')
            .then(m => m.AboutUsComponent)
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./Clients/Static-Pages/contact-us/contact-us.component')
            .then(m => m.ContactUsComponent)
      },
      {
        path: 'faqs',
        loadComponent: () =>
          import('./Clients/Static-Pages/faqs/faqs.component')
            .then(m => m.FaqsComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./Clients/Static-Pages/privacy-policy/privacy-policy.component')
            .then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./Clients/Static-Pages/terms/terms.component')
            .then(m => m.TermsComponent)
      }
    ]
  },
  {
    path: '',
    loadComponent: () => LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => DashboardComponent,
        children: [
          {
            path: '',
            redirectTo: '/flight',
            pathMatch: 'full'
          },
          {
            path: 'flight',
            loadComponent: () => import('../app/Clients/Flight/flight-request/flight-request.component').then(m => m.FlightRequestComponent)
          },
        ]
      }
    ]
  },
  {
    path: '',
    loadComponent: () => LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'flight-response',
        loadComponent: () =>
          import('./Clients/Flight/flight-response/flight-response.component')
            .then(m => m.FlightResponseComponent)
      },
      {
        path: 'flight-fare-details',
        loadComponent: () =>
          import('./Clients/Flight/flight-fare-details/flight-fare-details.component')
            .then(m => m.FlightFareDetailsComponent)
      },
      {
        path: 'flight/reservation',
        loadComponent: () =>
          import('./Clients/reservation/reservation.component')
            .then(m => m.ReservationComponent)
      },
      {
        path: 'flight/confirmation',
        loadComponent: () =>
          import('./Clients/Flight/confirmation/confirmation.component')
            .then(m => m.ConfirmationComponent)
      },
      {
        path: 'flight/payment-failed',
        loadComponent: () =>
          import('./Clients/Flight/payment-failed/payment-failed.component')
            .then(m => m.PaymentFailedComponent)
      },
      {
        path: 'admin/bookings',
        loadComponent: () =>
          import('./Clients/User-Dashboard/user-booking/user-booking.component')
            .then(m => m.UserBookingComponent)
      },
      {
        path: 'admin/booking-details/:bookingRefNo/:reservationId',
        loadComponent: () =>
          import('./Clients/User-Dashboard/user-booking/user-booking-details/user-booking-details.component')
            .then(m => m.UserBookingDetailsComponent)
      },
      {
        path: 'admin/manage-agent',
        loadComponent: () =>
          import('./Clients/manage-agent/manage-agent.component')
            .then(m => m.ManageAgentComponent)
      },
      {
        path: 'admin/agency-branch',
        loadComponent: () =>
          import('./Clients/agency-branch/agency-branch.component')
            .then(m => m.AgencyBranchComponent)
      },
      {
        path: 'admin/manage-roles',
        loadComponent: () =>
          import('./Clients/manage-roles/manage-roles.component')
            .then(m => m.ManageRolesComponent)
      },
      {
        path: 'admin/manage-agency-users',
        loadComponent: () =>
          import('./Clients/manage-agency-users/manage-agency-users.component')
            .then(m => m.ManageAgencyUsersComponent)
      },
      {
        path: 'admin/ledger',
        loadComponent: () =>
          import('./Clients/ledger/ledger.component')
            .then(m => m.LedgerComponent)
      },
      {
        path: 'admin/profile',
        loadComponent: () =>
          import('./Clients/User-Dashboard/user-profile/user-profile.component')
            .then(m => m.UserProfileComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
